import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBaseProperties } from "../base";
import { Product } from "../products/product";
export const PackingNoteItem = types
  .compose(
    Base,
    types.model({
      productId: types.maybeNull(types.string),
      product: types.maybeNull(Product),
      amount: types.maybeNull(types.number),
      orderNumber: types.maybeNull(types.number),
      boxNumber: types.maybeNull(types.string),
      grossWeight: types.maybeNull(types.number),
      netWeight: types.maybeNull(types.number),
      expiredDate: types.maybeNull(types.string),
    })
  )
  .actions(withSetPropAction);
export interface IPackingNoteItem extends Instance<typeof PackingNoteItem> {}
export interface IPackingNoteItemProperties
  extends SnapshotIn<typeof PackingNoteItem> {}

export interface IAddPackingNoteItem
  extends Omit<IPackingNoteItemProperties, "product" | keyof IBaseProperties> {}
export interface IUpdatePackingNoteItem
  extends Omit<IPackingNoteItemProperties, "product"> {}
